var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_512_549)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_549)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0876 12H21.9127C23.6224 12 24.9768 12 26.0363 12.1399C27.1266 12.2843 28.0093 12.5879 28.7061 13.2718C29.4019 13.9566 29.7107 14.8242 29.8577 15.8958C29.9414 16.5111 29.9758 17.227 29.9898 18.0562C30.002 18.1257 30.0032 18.1967 29.9935 18.2665C30 18.784 30 19.3435 30 19.9488V20.0512C30 21.7317 30 23.0629 29.8577 24.1042C29.7107 25.1758 29.4019 26.0434 28.7061 26.7282C28.0093 27.4121 27.1266 27.7157 26.0363 27.8601C24.9759 28 23.6224 28 21.9127 28H18.0876C16.3779 28 15.0235 28 13.964 27.8601C12.8738 27.7157 11.991 27.4121 11.2943 26.7282C10.5985 26.0434 10.2896 25.1758 10.1426 24.1042C10.0003 23.0619 10.0003 21.7317 10.0003 20.0512V19.9488C10.0003 19.3435 10.0003 18.784 10.0068 18.2665C9.99687 18.1967 9.99781 18.1258 10.0096 18.0562C10.0245 17.227 10.0589 16.5111 10.1426 15.8958C10.2896 14.8242 10.5985 13.9566 11.2943 13.2718C11.991 12.5879 12.8738 12.2843 13.964 12.1399C15.0244 12 16.3779 12 18.0876 12ZM11.3975 18.8571C11.3956 19.2119 11.3956 19.5922 11.3956 20C11.3956 21.7435 11.3975 22.9815 11.5259 23.9223C11.6515 24.8411 11.8877 25.3714 12.2812 25.7582C12.6747 26.1449 13.2142 26.3771 14.15 26.5006C15.1063 26.6267 16.3658 26.6286 18.1397 26.6286H21.8606C23.6345 26.6286 24.895 26.6267 25.8512 26.5006C26.7861 26.3771 27.3256 26.1449 27.7191 25.7582C28.1126 25.3714 28.3489 24.8411 28.4744 23.9214C28.6028 22.9815 28.6047 21.7435 28.6047 20C28.6047 19.5922 28.6047 19.2119 28.6028 18.8571H11.3975ZM28.5805 17.4857H11.4198C11.4384 16.949 11.4701 16.4855 11.5259 16.0777C11.6515 15.1589 11.8877 14.6286 12.2812 14.2418C12.6747 13.8551 13.2142 13.6229 14.15 13.4994C15.1063 13.3733 16.3658 13.3714 18.1397 13.3714H21.8606C23.6345 13.3714 24.895 13.3733 25.8512 13.4994C26.7861 13.6229 27.3256 13.8551 27.7191 14.2418C28.1126 14.6286 28.3489 15.1589 28.4744 16.0786C28.5303 16.4855 28.5619 16.949 28.5805 17.4857ZM13.7212 23.6571C13.7212 23.4753 13.7947 23.3008 13.9256 23.1723C14.0563 23.0437 14.2338 22.9714 14.4189 22.9714H18.1397C18.3247 22.9714 18.5022 23.0437 18.633 23.1723C18.7639 23.3008 18.8374 23.4753 18.8374 23.6571C18.8374 23.839 18.7639 24.0134 18.633 24.142C18.5022 24.2706 18.3247 24.3429 18.1397 24.3429H14.4189C14.2338 24.3429 14.0563 24.2706 13.9256 24.142C13.7947 24.0134 13.7212 23.839 13.7212 23.6571ZM19.7676 23.6571C19.7676 23.4753 19.8411 23.3008 19.972 23.1723C20.1028 23.0437 20.2802 22.9714 20.4653 22.9714H21.8606C22.0456 22.9714 22.2231 23.0437 22.3539 23.1723C22.4848 23.3008 22.5583 23.4753 22.5583 23.6571C22.5583 23.839 22.4848 24.0134 22.3539 24.142C22.2231 24.2706 22.0456 24.3429 21.8606 24.3429H20.4653C20.2802 24.3429 20.1028 24.2706 19.972 24.142C19.8411 24.0134 19.7676 23.839 19.7676 23.6571Z",
    fill: "#ECCFA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_549",
    x: 10,
    y: 12,
    width: 20,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_549",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#975B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B36996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37790"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.9559458bdaee0ce4887e9c8446409d25.svg";
export { ForwardRef as ReactComponent };